<mono-common-back-to-navigation-bar
data-test="lmw-base-browse-subjects-back-to-home-bar"
[linkText]="mobileBackButtonText"
linkTo="/"
position="back-to-navigation__top"></mono-common-back-to-navigation-bar>
<main id="content" #content class="browse browse--subjects" aria-describedby="ariaMainHeaderId">
  <div class="grid-container">
    <div class="grid-x">
      <div class="cell">
        <h1 id="ariaMainHeaderId">{{ browseSubjectsCms?.data?.attributes?.title }}</h1>
        <p class="lead" *ngIf="!userSignedIn" [innerHTML]="browseSubjectsCms?.data?.attributes?.registerNag | dontSanitizeHtml"></p>
        <p class="lead">{{ browseSubjectsCms?.data?.attributes?.description }}</p>
      </div>
    </div>
  </div>
  <div class="grid-container browse__list-container">
    <ul class="no-bullet grid-x">
      <li class="cell small-12 medium-6" *ngFor="let subject of subjects">
        <lmw-common-subject-topic-link-button [text]="subject.title" [slug]="subject.sk" type="subject" iconColour="primary-dark" data-test="lmw-base-browse-subjects-subject-topic-link-button">
        </lmw-common-subject-topic-link-button>
      </li>
    </ul>
  </div>
</main>
<ng-container *ngIf="!userSignedIn">
  <lmw-base-mobile-register-sign-in-bar [language]="language" data-test="lmw-base-browse-subjects-sign-in-bar"></lmw-base-mobile-register-sign-in-bar>
</ng-container>
<ng-container *ngIf="userSignedIn">
  <mono-common-back-to-navigation-bar
  data-test="lmw-base-browse-subjects-back-to-home-bar-bottom"
  [linkText]="mobileBackButtonText"
  linkTo="/"
  position="back-to-navigation__bottom"></mono-common-back-to-navigation-bar>
</ng-container>
